<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { ModelListSelect } from "vue-search-select";
import Loader from "@/components/widgets/preloader";
import appConfig from "@/app.config";
import { mapGetters, mapActions, mapState } from "vuex";
import moment from "moment";
import Swal from "sweetalert2";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Production Batches",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    Loader,
  },
  data() {
    return {
      title: "Production Batches",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "Production Batches",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: '',
      currentdate: moment(new Date()).format("YYYY-MM-DD"),

      payment: {
        id: "",
        date: moment(new Date()).format("YYYY-MM-DD"),
        paid: "",
        mode: "",
        filterdata: {}
      },
      data: {
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        datefrom: moment().subtract(1, 'months').format('YYYY-MM-DD'),
        factory: 'all',
        branch_id: 0
      },
      deleteData: {
        id: "",
      },
      editData: {
        id: "",
      },
      totals: {
        totalAmount: 0,
        totalBrand: 0,
        totalReceived: 0,
        totalBalance: 0,
        totalInputQty: 0,
      },
      amountError: "",
      modeError: "",
      balance: 0,
      filterTitle: "",
      filteredReport: [],
      json_fields: {
        "S/N": "SN",
        "BATCH ID": "BATCH_ID",
        "DATE": "DATE",
        "CUSTOMER": "CUSTOMER",
        "FACTORY": "FACTORY",
        "INPUT QTY": "INPUT_QTY",
        "INPUT PRICE": "INPUT_PRICE",
        "TOTAL COST": "TOTAL_COST",
        "TOTAL BRAND": "TOTAL_BRAND",
        "UNIT COST PRICE": "UNIT_COSTPRICE",
        "BRAND PRICE": "BRAND_PRICE",
        "LABOUR": "LABOUR",
        "RECEIVED": "RECEIVED",
        "BALANCE": "BALANCE",
        "BRAND %": "BRAND_PERCENTAGE",
        "PRODUCT %": "PRODUCT_PERCENTAGE",
        "LOSS %": "LOSS_PERCENTAGE",
        "RECORDED BY": "RECORDED_BY",
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
    };
  },
  computed: {
    ...mapGetters("production", ["ProductionBatches", "ProductionFactories", "filterStatus", "SaveStatus"]),
    ...mapGetters("auth", ["business", "branch", "branchid", "MyUserPerm", "Branches"]),
    ...mapGetters("setting", ["PaymentOptions", "GeneralSettings"]),
    ...mapState("notification", ["type", "message", "show"]),
    ...mapState("production", ["input_item"]),

    fields() {
      let baseFields = [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "batch_id",
          sortable: true,
          label: "ID",
        },
        {
          key: "input_quantity",
          sortable: true,
          label: `${this.input_item?this.input_item.data:'INPUT'} QTY`,
        },
        {
          key: "product_quantity",
          sortable: true,
          label: "PRODUCT QUANTITY",
        },
        {
          key: "brand_quantity",
          sortable: true,
          label: "BRAND QUANTITY",
        },
        {
          key: "brand%ge",
          sortable: true,
          label: "BRAND %ge",
        },
        {
          key: "product%ge",
          sortable: true,
          label: "PRODUCT %ge",
        },
        {
          key: "loss",
          sortable: true,
          label: "LOSS %ge",
        },
        {
          key: "factory",
          sortable: true,
          label: "FACTORY",
        },
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "user",
          sortable: true,
          label: "RECORDED BY",
        },
        {
          key: "actions",
          sortable: true,
          label: "ACTION",
        }
      ];
      return baseFields;
    },

    formattedFactories() {
      const factories = Array.isArray(this.ProductionFactories)
        ? this.ProductionFactories
        : Array.isArray(this.ProductionFactories?.data)
          ? this.ProductionFactories.data
          : []

      return [
        { id: 'all', name: 'All Factories', location: '' },
        { id: '', name: 'Main Factory', location: '' },
        ...factories
      ].map(factory => ({
        ...factory,
        display_name: factory.location
          ? `${factory.name} - ${factory.location}`
          : factory.name
      }))
    },

    /**
     * Total no. of records
     */

    rows() {
      return this.ProductionBatches ? this.ProductionBatches.length : 1;
    },

    exportData() {
      if (!this.ProductionBatches) return [];

      return this.ProductionBatches.map((item, index) => {
        const totalCost = parseInt(item.total_cost) || 0;
        const totalBrand = parseInt(item.total_brand) || 0;
        const received = parseInt(item.received_amount) || 0;

        return {
          SN: index + 1,
          BATCH_ID: item.batch_id,
          DATE: item.date,
          CUSTOMER: item.customer,
          FACTORY: item.factory,
          INPUT_QTY: item.input_quantity,
          INPUT_PRICE: this.thousandSeperator(item.input_price),
          TOTAL_COST: this.thousandSeperator(totalCost),
          TOTAL_BRAND: this.thousandSeperator(totalBrand),
          UNIT_COSTPRICE: this.thousandSeperator(item.cost_price),
          BRAND_PRICE: this.thousandSeperator(item.brand_sellingprice),
          LABOUR: this.thousandSeperator(item.total_labour),
          RECEIVED: this.thousandSeperator(received),
          BALANCE: this.thousandSeperator(totalBrand - (totalCost + received)),
          BRAND_PERCENTAGE: item["brand%ge"],
          PRODUCT_PERCENTAGE: item["product%ge"],
          LOSS_PERCENTAGE: item["loss"],
          RECORDED_BY: item.user,
        };
      });
    }

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.ProductionBatches ? this.ProductionBatches.length : 1;
  },
  methods: {
    ...mapActions({
      FetchProductionBatches: "production/fetchProductionBatches",
      EditBatch: "production/editBatch",
      DeleteBatch: "production/deleteBatch",
      FetchGeneralSettings: "setting/fetchGeneralSettings",
      FetchProductionFactories: "production/fetchProductionFactories",
      FetchModes: "setting/fetchPaymentOptions",
      ReceivePayment: "production/receivedAmount",
      FetchBraches: "auth/fetchBranches",
      GetInputItem: "production/getInputItem",
    }),
    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m === null || m === undefined || m === "") return "0";
      const num = parseFloat(m.toString().replace(/,/g, ""));
      if (isNaN(num)) return "0";
      return num.toLocaleString();
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    filterReport() {
      this.FetchProductionBatches(this.data);
    },

    Viewmovements(id) {
      if (id) {
        this.$router.push(`/factory_stock/batch_stock_movements/${btoa(id)}`);
      }
    },
    showEditModal(data) {
      this.editData.id = data.item.id;
    },
    showDeleteModal(data) {
      this.deleteData.id = data.item.id;
    },
    resetDelete() {
      this.deleteData.id = "";
    },
    resetEdit() {
      this.editData.id = "";
    },
    editBatch(modalId) {
      this.modal_id = modalId;
      this.EditBatch(this.editData);
    },
    deleteBatch(modalId) {
      this.modal_id = modalId;
      this.DeleteBatch(this.deleteData);
    },
    closeModal(modalId) {
      this.resetDelete();
      this.resetEdit();
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },

    setDefaultMode() {
      let defaultop = this.PaymentOptions ? this.PaymentOptions : [].filter((mode) => {
        return mode.default == 1;
      })
      this.payment.mode = defaultop[0] ? defaultop[0].id : 0;
    },
    resetModal() {
      this.payment.id = "";
      this.payment.paid = "";
      this.setDefaultMode();
    },
    resetError() {
      this.amountError = "";
      this.modeError = "";
    },
    addCommas() {
      this.payment.paid = this.thousandSeperator(this.payment.paid);
    },
    showPaymentModal(data) {
      this.payment.id = data.id;
      this.balance = (data.total_brand - (data.total_cost + data.received_amount));
      this.payment.paid = (parseInt(data.total_brand) - (parseInt(data.total_cost) + parseInt(data.received_amount))).toLocaleString();
    },
    checkAmt() {
      if (this.payment.paid.replace(/,/g, '') > this.balance) {
        this.amountError = "Amount Paid is greater than balance";
        return
      }
      else {
        this.amountError = "";
      }
    },
    payAmt(modalId) {
      this.modal_id = modalId;
      if (this.payment.paid == "") {
        this.amountError = "Amount Paid is required";
        return
      }
      else {
        this.amountError = "";
      }
      if (this.payment.paid.replace(/,/g, '') > this.balance) {
        this.amountError = "Amount Paid is greater than balance";
        return
      }
      else {
        this.amountError = "";
      }
      if (this.payment.mode == "") {
        this.modeError = "Payment Method is required";
        return
      }
      else {
        this.modeError = "";
      }
      this.payment.filterdata = this.data;
      this.ReceivePayment(this.payment);
    },

  },

  updated() {
    let total_amount = 0;
    let total_brand = 0;
    let total_received = 0;
    let total_inputqty = 0;
    // let total_paid = 0;
    if (this.ProductionBatches) {
      this.ProductionBatches.forEach((item) => {
        total_amount = total_amount + parseInt(item.total_cost);
        total_brand = total_brand + parseInt(item.total_brand);
        total_received = total_received + parseInt(item.received_amount);
        total_inputqty = total_inputqty + parseInt(item.input_quantity.replaceAll(/,/g, ''));
      });
      this.totals.totalAmount = total_amount;
      this.totals.totalBrand = total_brand;
      this.totals.totalReceived = total_received;
      this.totals.totalBalance = total_brand - (total_amount + total_received);
      this.totals.totalInputQty = total_inputqty;
    }
  },

  watch: {
    ProductionCart(newValue) {
      if (newValue) {
        // this.updateTotals();
      }
    },
    show(newValue) {
      // Do whatever makes sense now
      if (newValue) {
        if (this.type == "success") {
          this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
    branchid(newValue) {
      if (newValue && newValue == 0) {
        this.FetchBraches();
      }
    }
  },

  created() {
    this.FetchProductionBatches(this.data);
    this.FetchGeneralSettings();
    this.FetchProductionFactories();
    this.FetchModes()
    this.setDefaultMode();
    this.GetInputItem();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">

            <!-- Filter Title -->
            <div v-if="filterTitle" class="text-center mb-3">
              <h4>{{ filterTitle }}</h4>
            </div>

            <!-- FILTER SECTION -->
            <div class="row align-items-end g-2">

              <div class="col-12 col-md-3">
                <label>From</label>
                <input type="date" v-model="data.datefrom" class="form-control" />
              </div>

              <div class="col-12 col-md-3">
                <label>To</label>
                <input type="date" v-model="data.dateto" class="form-control" />
              </div>

              <div class="col-12 col-md-3">
                <label>Filter by factory</label>
                <model-list-select :list="formattedFactories" v-model="data.factory" option-value="id"
                  option-text="display_name" placeholder="Select Factory" @input="filterReport()">
                </model-list-select>
              </div>

              <div v-if="branchid == 0" class="col-auto">
                <label>FILTER BY BRANCHES</label>
                <model-list-select :list="Branches ? [{ id: 0, name: 'All Branches' }, ...Branches] : []"
                  v-model="data.branch_id" option-value="id" option-text="name" placeholder="Select Branch"
                  @input="filterReport()">
                  <option :value="0">All Branches</option>
                </model-list-select>
              </div>

              <div class="col-auto">
                <button class="btn btn-primary mt-2" @click="filterReport()"
                  style="background-color: #e612e6 !important; border-color: #e612e6 !important; color: #fff !important;">
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner v-show="filterStatus" variant="light" small></b-spinner>
                </button>
              </div>

              <div class="col-auto">
                <download-excel class="btn btn-primary w-100" :data="exportData" :fields="json_fields"
                  :worksheet="'PRODUCTION BATCHES FOR ' + currentdate" type="csv"
                  :name="'ProductionBatches_' + data.datefrom + '_to_' + data.dateto + '.xls'">
                  Export Excel <i class="fa fa-file-excel"></i>
                </download-excel>
              </div>
            </div>

            <!-- SEARCH + ENTRIES -->
            <div class="row mt-3 g-2">

              <div class="col-12 col-md-6">
                <label class="d-flex align-items-center">
                  Show&nbsp;
                  <b-form-select class="form-select form-select-sm w-auto" v-model="perPage" size="sm"
                    :options="pageOptions"></b-form-select>
                  &nbsp;entries
                </label>
              </div>

              <div class="col-md-6 col-auto text-md-end">
                <label class="d-flex align-items-center justify-content-md-end">
                  Search:
                  <b-form-input v-model="filter" type="search" placeholder="Search..."
                    class="form-control form-control-sm ms-2"></b-form-input>
                </label>
              </div>

            </div>

            <!-- Table -->
            <div class="table-responsive mb-2">
              <b-table :items="ProductionBatches || []" :fields="fields" responsive="sm" :per-page="perPage"
                :current-page="currentPage" :sort-desc.sync="sortDesc" :filter="filter"
                :filter-included-fields="filterOn" @filtered="onFiltered">
                <template #cell(index)="data">{{ data.index + 1 }}</template>
                <!-- Actions: Horizontal Row -->
                <template #cell(actions)="data">
                  <div class="d-flex flex-wrap gap-1">
                    <b-button variant="success" size="sm" @click="Viewmovements(data.item.id)">Movements</b-button>
                  </div>
                </template>
              </b-table>
            </div>

            <!-- Totals -->
            <div class="row text-center mt-3">
              <div class="col-12 col-md-4">
                <h5>
                  Total {{
                    (input_item && input_item.data
                      ? input_item.data
                      : 'INPUT'
                    ).toString().charAt(0).toUpperCase() +
                    (input_item && input_item.data
                      ? input_item.data
                      : 'INPUT'
                    ).toString().slice(1).toLowerCase()
                  }} Quantity:
                  <span class="text-danger">
                    {{ totals.totalInputQty > 0 ? totals.totalInputQty.toLocaleString() : 0 }}
                  </span>
                </h5>
              </div>
              <div class="col-12 col-md-4">
                <h5>Total Cost: <span class="text-danger">{{ totals.totalAmount > 0 ?
                  totals.totalAmount.toLocaleString() : 0
                }}</span></h5>
              </div>
              <div class="col-12 col-md-4">
                <h5>Total Brand: <span class="text-danger">{{ totals.totalBrand > 0 ? totals.totalBrand.toLocaleString()
                  : 0
                }}</span></h5>
              </div>
              <div class="col-12 col-md-6">
                <h5>Total Received Amount: <span class="text-danger">{{ totals.totalReceived > 0 ?
                  totals.totalReceived.toLocaleString() : 0 }}</span></h5>
              </div>
              <div class="col-12 col-md-6">
                <h5>Total Balance (Brand - (Cost+Received)): <span class="text-danger">{{ totals.totalBalance ?
                  totals.totalBalance.toLocaleString() : 0 }}</span></h5>
              </div>
            </div>

            <!-- Modals -->
            <!-- edit modal starts -->
            <b-modal header-bg-variant="warning" header-text-variant="light" body-text-variant="warning"
              footer-bg-variant="warning" footer-text-variant="warning" id="edit-batch-modal" hide-footer
              @hidden="resetEdit">
              <template #modal-title> Edit This Batch</template>
              <div class="form-group mb-2">
                <div class="input-group">
                  <h5>
                    Do you want to return and edit this Batch? Click Proceed Button to Return this Batch for Editing.
                  </h5>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal"
                  @click="closeModal('edit-batch-modal')">
                  <i class="fa fa-times"></i> Close
                </button>
                <button type="button" class="btn btn-primary" @click="editBatch('edit-batch-modal')">
                  <i class="fa fa-edit"></i> Proceed
                  <b-spinner v-if="SaveStatus" variant="light" small label="Deleting"></b-spinner>
                </button>
              </div>
            </b-modal>
            <!-- edit modal ends -->

            <!-- delete modal begins -->
            <b-modal header-bg-variant="danger" header-text-variant="light" body-text-variant="danger"
              footer-bg-variant="danger" footer-text-variant="danger" id="delete-batch-modal" hide-footer
              @hidden="resetDelete">
              <template #modal-title> Delete This Batch</template>
              <div class="form-group mb-2">
                <div class="input-group">
                  <h5>
                    Do you want to delete this Batch? Click Proceed Button to delete.
                  </h5>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal"
                  @click="closeModal('delete-batch-modal')">
                  <i class="fa fa-times"></i> Close
                </button>
                <button type="button" class="btn btn-danger" @click="deleteBatch('delete-batch-modal')">
                  <i class="fa fa-trash"></i> Proceed
                  <b-spinner v-if="SaveStatus" variant="light" small label="Deleting"></b-spinner>
                </button>
              </div>
            </b-modal>
            <!-- delete modal ends -->

            <!-- batch payment modal starts -->
            <b-modal id="batch-payment-modal" hide-footer @hidden="resetModal()">
              <template #modal-title>
                <h4 class="text-warning">Receive Payment of {{ (payment.paid).toLocaleString() }}</h4>
              </template>
              <label>Amount Paid <span class="text-danger">*</span></label>
              <div class="input-group">
                <input type="text" class="form-control" v-model="payment.paid" placeholder="Amount Paid"
                  @input="resetError(), addCommas(), checkAmt()" />
              </div>
              <div class="text-danger" v-if="amountError">
                <em>{{ amountError }}</em>
              </div>
              <div class="form-group">
                <label>Payment Method <span class="text-danger">*</span></label>
                <model-list-select :list="PaymentOptions ? PaymentOptions : []" v-model="payment.mode" option-value="id"
                  option-text="mode" placeholder="Select Method" @input="resetError()">
                </model-list-select>
              </div>
              <div class="text-danger" v-if="modeError">
                <em>{{ modeError }}</em>
              </div>
              <label>Payment Date</label>
              <div class="input-group">
                <input type="date" class="form-control" v-model="payment.date" v-limit-future-date />
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal"
                  @click="closeModal('batch-payment-modal')">
                  <i class="fa fa-times"></i> Close
                </button>
                <button v-if="SaveStatus" type="button" class="btn btn-warning" disabled>
                  Submitting....
                  <b-spinner variant="light" small label="Submiting"></b-spinner>
                </button>
                <button v-else type="button" class="btn btn-warning" @click="payAmt('batch-payment-modal')">
                  Submit
                </button>
              </div>
            </b-modal>

            <Loader v-if="!ProductionBatches" />

            <!-- Pagination: Always Right-Aligned -->
            <div class="row mt-2">
              <div class="col-12 d-flex justify-content-end">
                <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" size="sm"></b-pagination>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
/* Keep buttons compact */
.btn {
  white-space: nowrap;
  min-width: 100px;
}

/* Table actions horizontal alignment fix */
.table-responsive .d-flex.gap-1 {
  flex-wrap: wrap;
}
</style>
